module.exports = __webpack_public_path__ + "img/logo.c74ca671.png";